// src/pages/ResetPassword.jsx

import { useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { useNavigate } from "react-router-dom";
import notify from '../lib/notify';
import { Button as FcButton, Input as FcInput } from '../ui';
// layout matches Login.jsx style (ribbon header + split card)

export default function ResetPassword({ session, userRole, username }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async () => {
    if (!password || password.length < 6) {
      notify("Password must be at least 6 characters long.", 'info');
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);

    if (error) {
      notify("Reset failed: " + error.message, 'error');
    } else {
      notify("✅ Password updated. Please log in.", 'success');
      navigate("/login");
    }
  };

  return (
    <div className="min-h-screen bg-surface-canvas flex flex-col">
      {/* Green ribbon header */}
      <div className="w-full bg-ui-green py-5 px-6 flex items-center">
        <span className="text-white text-xl font-semibold">Footy Coach</span>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <div className="w-full max-w-4xl rounded-lg shadow-md flex flex-col md:flex-row overflow-hidden m-4">
          {/* Left: Reset Form */}
          <div role="main" id="fc-main-content" className="flex-1 bg-surface-card flex flex-col justify-center p-8">
            <h1 className="text-3xl font-bold text-black mb-8 text-center md:text-left">Reset Password</h1>
            <div className="space-y-6">
              <div>
                <label htmlFor="password" className="block font-semibold mb-1 text-black">New Password</label>
                <FcInput
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border"
                  placeholder="New Password"
                  required
                />
              </div>
              <FcButton variant="primary" type="submit"
                onClick={handleReset}
                className="w-full"
                disabled={loading}
              >
                {loading ? "Updating..." : "Set New Password"}
              </FcButton>
            </div>
            <div className="mt-6 text-center text-black text-base">
              <span>Remembered your password? </span>
              <a href="/login" className="text-action-primary font-semibold hover:underline">Log in</a>
            </div>
          </div>
          {/* Right: FC Logo (desktop only) */}
          <div className="hidden md:flex flex-1 items-center justify-center bg-ui-green">
            <span className="text-[10vw] font-bold text-ui-copper select-none">FC</span>
          </div>
        </div>
      </div>
    </div>
  );
}
